/**
 * @module profile/components/portfolio/entry_details_header
 */
import React, { PropTypes, Component } from 'react';
import { v4 } from 'node-uuid';
import SingleEntryHeader from 'common/components/modal/single_entry_header';
import Avatar from 'common/components/avatar';

/**
 * Header component for the portfolio single entry modal.
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
class EntryDetailsHeader extends Component {
  /*
   * Prepare data to render entry dropdown
   */
  getEntryDropdown() {
    const { userAccess } = this.props;
    const elements = [];

    if (!userAccess.isOwner) {
      elements.push(
        <li key={v4()}>
          <button type="button" onClick={this.toggleEntryDropdown} >
            <i className="fa fa-thumbs-up" aria-hidden="true" />
            Like this Design
          </button>
        </li>
      );
    }

    elements.push(
      (<li key={v4()}>
        <button type="button" onClick={this.toggleEntryDropdown} >
          <i className="fa fa-twitter" aria-hidden="true" />
          Share on Twitter
        </button>
      </li>),
      (<li key={v4()}>
        <button type="button" onClick={this.toggleEntryDropdown} >
          <i className="fa fa-facebook" aria-hidden="true" />
          Share on Facebook
        </button>
      </li>),
      (<li key={v4()}>
        <button type="button" onClick={this.toggleEntryDropdown} >
          <i className="fa fa-dribble" aria-hidden="true" />
          Post to Dribble
        </button>
      </li>)
    );

    if (userAccess.isOwner) {
      elements.push(
        <li key={v4()}>
          <button type="button" onClick={this.toggleEntryDropdown} >
            <i className="fa fa-ban" aria-hidden="true" />
            Report Violation
          </button>
        </li>
      );
    }

    return elements;
  }

  /*
   * Prepare data to render top header element
   */
  getTopHeader() {
    const { pageNumber, itemsCount, onNextPage,
      onPrevPage, onToggleEntryDetails, creative } = this.props;
    const leftElement = (
      <span onClick={onToggleEntryDetails} className="header-link">
        <i className="fa fa-angle-left"/> {creative.username}&apos;s Portfolio
      </span>
    );

    const params = {
      leftElement,
      pageNumber,
      itemsCount,
      onNextPage,
      onPrevPage,
      onToggleDetails: onToggleEntryDetails,
    };

    return params;
  }

  /*
   * Prepare data to render bottom header element
   */
  getBottomHeader() {
    const { creative } = this.props;

    const leftElement = (
      <div key={v4()} className="row small-collapse creative-info">
        <Avatar user={creative} extraClasses="avatar-sm" />
        <h3 className="column">
          { creative.username }
        </h3>
      </div>
    );

    return {
      leftControls: [leftElement],
      rater: null,
      buttons: null,
    };
  }

  render() {
    const topHeaderData = this.getTopHeader();
    const bottomHeaderData = this.getBottomHeader();
    // FIXME: show dropdown with share links once we have URLs for specific portfolio items
    //const entryDropdownData = this.getEntryDropdown();
    const entryDropdownData = null;

    return (
      <SingleEntryHeader
        cssClasses={'single-portfolio'}
        topHeaderData={topHeaderData}
        bottomHeaderData={bottomHeaderData}
        dropdownData={entryDropdownData}
        {...this.props}
      />
    );
  }
}

/**
 * PropTypes.
 *
 * @property {object} creative - author data object
 * @property {object} userAccess - object with user access rights
 * @property {object} entry - entry data object
 * @property {number} pageNumber - current page
 * @property {number} itemsCount - total number of elements
 * @property {func} onToggleEntryDetails - function called when modal should be closed
 * @property {func} onToggleLeftDrawer - function called when reft drawer should be shown
 * @property {func} onPrevPage - function called when previous object is requested
 * @property {func} onNextPage - function called when next object is requested
 */
EntryDetailsHeader.propTypes = {
  creative: PropTypes.object,
  userAccess: PropTypes.object,
  entry: PropTypes.object,
  pageNumber: PropTypes.number,
  itemsCount: PropTypes.number,
  onToggleEntryDetails: PropTypes.func,
  onToggleLeftDrawer: PropTypes.func,
  onPrevPage: PropTypes.func,
  onNextPage: PropTypes.func,
};

export default EntryDetailsHeader;



// WEBPACK FOOTER //
// ./profile/components/portfolio/entry_details_header.jsx